import { Sheet } from '@/components/shared/Sheet';
import { Avatar } from '@/components/shared/Avatar';

const GOLF = Array.from({ length: 8 }, (_, i) => `golf:${i + 1}`);
const CARTOON = Array.from({ length: 6 }, (_, i) => `cartoon:${i + 1}`);
const SERVICE = Array.from({ length: 4 }, (_, i) => `service:${i + 1}`);

interface Props {
  member: { name: string; avatar?: string | null };
  current: string | null;
  onClose: () => void;
  onSelect: (avatar: string) => void;
}

export function AvatarPicker({ member, current, onClose, onSelect }: Props) {
  const Section = ({ title, items }: { title: string; items: string[] }) => (
    <div>
      <div className="mb-2 text-xs font-bold uppercase tracking-wider text-slate-400">{title}</div>
      <div className="grid grid-cols-4 gap-2">
        {items.map((id) => (
          <button
            key={id}
            type="button"
            onClick={() => { onSelect(id); onClose(); }}
            className={`flex flex-col items-center gap-1 rounded-xl p-2 ${current === id ? 'bg-gold/20 ring-2 ring-gold' : 'bg-slate-50'}`}
          >
            <Avatar member={{ name: member.name, avatar: id }} size={44} />
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <Sheet title="Choose Avatar" onClose={onClose}>
      <div className="space-y-5 p-4">
        <Section title="Golf" items={GOLF} />
        <Section title="Cartoon" items={CARTOON} />
        <Section title="Service" items={SERVICE} />
      </div>
    </Sheet>
  );
}
